import { authenticatedFetch } from "./utils";
import API_CONSTANTS from "../constants/api";
import { campaignStore } from "../stores/campaign";
import { sessionStore } from "../stores/session";
import { get } from "svelte/store";

const track = async (endpoint: string): Promise<void> => {
  try {
    const url = `${API_CONSTANTS.frontendBaseUrl}/v1/track/${endpoint}`;

    const baseData = {
      campaign: get(campaignStore).campaign?.campaign_key,
      organization_id: get(campaignStore).campaign?.organization_id,
      channel: get(sessionStore).foojiData?.campaign_user?.channel
    };

    await authenticatedFetch(url, {
      method: "POST",
      body: JSON.stringify(baseData)
    }, undefined, undefined, { skipAllErrorHandling: true });
  } catch (error) {
    console.log("Error tracking event", error);
    // TODO: bugsnag error
  }
};

export const trackSiteVisit = () => void (track("site-visit"));
